import { Container } from "./styles";
import illu from "../../assets/illu.svg"
import ScrollAnimation from "react-animate-on-scroll";


import react from "../../assets/react-icon.svg"
import node from "../../assets/node-icon.svg"
import js from "../../assets/js-icon.svg"
import vue from "../../assets/vue-icon.svg"
import mongo from "../../assets/mongo-icon.svg"
import html from "../../assets/html-icon.svg"
import css from "../../assets/css3-icon.svg"
import metamaska from "../../assets/metamaska.svg"


export function Portfolio(){
  return(
    <Container id="portfolio">
      <h2>My portfolio</h2>

      <div className="projects">
        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://github.com/joaotuliojt/fc-squad43" target="_blank" rel="noreferrer">
                  <img src={node} alt="GitHub" />
                </a>
                <a href="https://github.com/joaotuliojt/fc-squad43" target="_blank" rel="noreferrer">
                  <img src={react} alt="GitHub" />
                </a>
                <a href="https://github.com/joaotuliojt/fc-squad43" target="_blank" rel="noreferrer">
                  <img src={js} alt="GitHub" />
                </a>
                <a href="https://github.com/joaotuliojt/fc-squad43" target="_blank" rel="noreferrer">
                  <img src={mongo} alt="GitHub" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Status</h3>
              <p>It will help to create a memory along with the experience of the people with cool Pictures.
                <br></br>
                <br></br>
                <a href="https://statusa.netlify.app/" target="_blank" rel="noreferrer">status</a>
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Node</li>
                <li>Express</li>
                <li>MongoDB</li>
                <li>React</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://github.com/joaotuliojt/github-search" target="_blank" rel="noreferrer">
                  <img src={html} alt="GitHub" />
                </a>
                <a href="https://github-search-blond.vercel.app/" target="_blank" rel="noreferrer">
                  <img src={css} alt="Visitar site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Love With Css</h3>
              <p>There is always some madness in love. But there is also always some reason in madness.
                <br></br>
                <br></br>
                <a href="https://lovewithcss.netlify.app/" target="_blank" rel="noreferrer">love</a>
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>HTML</li>
                <li>CSS</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project" onClick={() => {}}>
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://joaotuliojt.github.io/sunnyside-agency/" target="_blank" rel="noreferrer">
                  <img src={vue} alt="Visitar site" />
                </a>
                <a href="https://joaotuliojt.github.io/sunnyside-agency/" target="_blank" rel="noreferrer">
                  <img src={css} alt="Visitar site" />
                </a>
                <a href="https://joaotuliojt.github.io/sunnyside-agency/" target="_blank" rel="noreferrer">
                  <img src={html} alt="Visitar site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>SpeedUp</h3>
              <p>Simple and elegant UI application helps those people who want to speed up their 
                typing speed with a focused way with an interactive keyboard.
                <br></br>
                <br></br>
                <a href="https://speed-up-my-typing.netlify.app/" target="_blank" rel="noreferrer">speedup</a>
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Html</li>
                <li>Css</li>
                <li>Vue</li>
                <li>JavaScript</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://joaotuliojt.github.io/sunnyside-agency/" target="_blank" rel="noreferrer">
                  <img src={vue} alt="Visitar site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>MrCipher</h3>
              <p>Not Deployed
                <br></br>
                <br></br>
                <a href="" target="_blank" rel="noreferrer">soon</a>
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React</li>
                <li>Tailwind Css</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://joaotuliojt.github.io/sunnyside-agency/" target="_blank" rel="noreferrer">
                  <img src={metamaska} alt="Visitar site" />
                </a>
                <a href="https://github.com/joaotuliojt/fc-squad43" target="_blank" rel="noreferrer">
                  <img src={node} alt="GitHub" />
                </a>
                <a href="https://github.com/joaotuliojt/fc-squad43" target="_blank" rel="noreferrer">
                  <img src={react} alt="GitHub" />
                </a>
                <a href="https://github.com/joaotuliojt/fc-squad43" target="_blank" rel="noreferrer">
                  <img src={js} alt="GitHub" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Web3.0</h3>
              <p>Work Going On
                <br></br>
                <br></br>
                <a href="" target="_blank" rel="noreferrer">soon</a>
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Metamask</li>
                <li>React</li>
                <li>Node</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="" target="_blank" rel="noreferrer">
                  <img src={vue} alt="Visitar site" />
                </a>
                <a href="" target="_blank" rel="noreferrer">
                  <img src={css} alt="Visitar site" />
                </a>
                <a href="" target="_blank" rel="noreferrer">
                  <img src={html} alt="Visitar site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>EdHusk</h3>
              <p>EdHusk is a Edtech startup, where I Worked with brilliant mindsets and great mentor.
                <br></br>
                <br></br>
                <a href="https://www.edhusk.com/" target="_blank" rel="noreferrer">edhusk</a>
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Html</li>
                <li>Css</li>
                <li>Vue</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>
      </div>
    </Container>
  );
}